module.exports = ".options{padding:10px}.vertical-align{position:fixed;top:50%;left:50%;transform:translate(-50%, -50%)}@media (max-height: 570px){.user{display:none}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidenav/sidenav.component.scss
// module id = 652
// module chunks = 0